import type { FacilityUserPayload } from '@Application/Users/FacilityUsers/Actions/facilityUsersFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class FacilityUserView {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly isActive: boolean;

	constructor(payload: FacilityUserPayload) {
		this.id = payload.id;
		this.firstName = payload.firstName;
		this.lastName = payload.lastName;
		this.isActive = payload.isActive;

		Object.freeze(this);
	}

	get fullName(): string {
		return `${this.firstName} ${this.lastName}`;
	}
}

export default FacilityUserView;
